import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-module-placeholder',
  standalone: true,
  template: `
    <section class="placeholder">
      <p>DESKPLUS ONE</p>
      <h1>{{ title }}</h1>
      <span>
        Esta seccion ya forma parte del shell. La funcionalidad real se
        implementara en su bloque correspondiente.
      </span>
    </section>
  `,
  styles: [`
    .placeholder {
      max-width: 900px;
      padding: 34px;
      border: 1px solid #e5eaf2;
      border-radius: 18px;
      background: #fff;
      box-shadow: 0 9px 30px rgba(18,33,63,.045);
    }

    p {
      margin: 0 0 9px;
      color: #557ce9;
      font-size: 9px;
      font-weight: 800;
      letter-spacing: .14em;
    }

    h1 {
      margin: 0 0 12px;
      color: #17223b;
      font-size: 34px;
      letter-spacing: -.04em;
    }

    span {
      color: #71809a;
      font-size: 12px;
      line-height: 1.65;
    }
  `]
})
export class ModulePlaceholderComponent {
  private readonly route = inject(ActivatedRoute);
  readonly title = this.route.snapshot.data['title'] ?? 'Modulo DeskPlus One';
}
